@if (affairLoading) {
  <div class="absolute inset-0 grid bg-neutral-950 bg-opacity-70 h-full">
    <p-progressSpinner ariaLabel="loading" class="m-auto" />
  </div>
}

<!-- Ajouter le composant ConfirmDialog pour les confirmations -->
<p-confirmDialog
  [style]="{ width: '450px' }"
  styleClass="p-confirm-dialog-custom"
></p-confirmDialog>

<p-card
  styleClass="w-full flex flex-1 relative"
  class="stepper-card"
  *ngIf="affair"
>
  <div class="flex flex-col w-full h-full overflow-hidden">
    <!-- Header with affair information and steps -->
    <div class="header-steps-container">
      <!-- Informations de l'affaire -->
      <div class="affair-header-section">
        <div class="affair-info-content">
          <h2 class="affair-title">
            {{ affair.mlRef }} - {{ affair.finalCustomerLastname }}
            <ng-container *ngIf="affair.finalCustomerLastnameSecondary">
              / {{ affair.finalCustomerLastnameSecondary }}
            </ng-container>
          </h2>
          <span class="affair-location" *ngIf="affair.workSiteLocality">
            <i class="pi pi-map-marker"></i> {{ affair.workSitePostalCode }}
            {{ affair.workSiteLocality }}
          </span>
        </div>
      </div>

      <!-- Étapes -->
      <div class="steps-section">
        <p-steps
          [(activeIndex)]="activeStep"
          [model]="steps"
          styleClass="modern-steps"
        ></p-steps>
      </div>
    </div>

    <!-- Step content -->
    <div class="mt-4 w-full flex-grow flex flex-col">
      <div
        class="step-content w-full flex-grow overflow-auto"
        [ngSwitch]="activeStep()"
      >
        <!-- NEW Step 1: Product Selection -->
        <div *ngSwitchCase="0" class="w-full">
          <app-affair-schedule-products-select
            [affair]="affair"
            [products]="products"
            [loadingProducts]="loadingProducts"
            [restoredSelectedProductIds]="getRestoredProductIds()"
            [restoredProductGroup]="
              productGroups.length ? productGroups[0] : null
            "
            [resetSelection]="productResetFlag"
            (productSelectionChanged)="onProductSelectionChanged($event)"
            (productGroupCreated)="onProductGroupCreated($event)"
          ></app-affair-schedule-products-select>
        </div>

        <!-- Step 2 (was Step 1): Technician Selection -->
        <div *ngSwitchCase="1" class="w-full">
          <app-affair-schedule-technicians-select
            class="w-full flex"
            [affair]="affair"
            [users]="users$ | async"
            [selectedProducts]="selectedProducts"
            [loadingUsers]="loadingUsers"
            [resetMap]="resetMapFlag"
            [isActive]="activeStep() === 1"
            [initialDateRange]="
              dateRange().length === 2 ? [dateRange()[0], dateRange()[1]] : null
            "
            (techniciansSelected)="onTechniciansSelected($event)"
            (dateRangeSelected)="onDateRangeSelectedFromStep1($event)"
            (closestInterventionsChanged)="
              onClosestInterventionsChanged($event)
            "
            (techniciansByRouteChanged)="onTechniciansByRouteChanged($event)"
            (selectedInterventionChanged)="
              onSelectedInterventionChanged($event)
            "
            (preSelectedSlotChanged)="onPreSelectedSlotChanged($event)"
            (batchIndicatorsChanged)="onBatchIndicatorsChanged($event)"
            (slotPreSelected)="onSlotPreSelected($event)"
          ></app-affair-schedule-technicians-select>
        </div>

        <!-- Remaining steps with updated indexes -->
        <div *ngSwitchCase="2" class="w-full">
          <app-affair-schedule-time-select
            class="w-full"
            [affair]="affair"
            [selectedTechnicians]="selectedTechnicians"
            [selectedDateRange]="dateRange()"
            [users]="users$ | async"
            [loadingUsers]="loadingUsers"
            [droppedEventDetails]="droppedDetails"
            [resetCalendar]="calendarReset"
            [closestInterventions]="closestInterventions"
            [selectedProducts]="selectedProducts"
            [productGroups]="productGroups"
            [returningToStep]="returningToCalendarStep"
            [preSelectedSlot]="preSelectedSlotData"
            (dropDetails)="onDropDetails($event)"
            (dateRangeChange)="onDateRangeSelected($event)"
            (filtersChanged)="updateFilters($event)"
          ></app-affair-schedule-time-select>
        </div>

        <div *ngSwitchCase="3" class="w-full">
          <app-affair-schedule-intervention-schedule
            class="w-full"
            [droppedDetails]="droppedDetails"
            [selectedTechnicians]="selectedTechnicians"
            [scheduleForm]="scheduleForm"
            [dateRange]="dateRange()"
            [usersList]="interventionScheduleUsers"
            (formScheduleChanged)="onScheduleChanged($event)"
            (formStateChanged)="onFormStateChanged($event)"
            (techniciansIncompatibleErpChanged)="
              techniciansIncompatible = $event
            "
          ></app-affair-schedule-intervention-schedule>
        </div>

        <div *ngSwitchCase="4" class="w-full">
          <!-- Afficher message d'erreur si nécessaire -->
          <div
            *ngIf="interventionError"
            class="p-4 mb-4 bg-red-100 border border-red-300 rounded-lg shadow-sm"
          >
            <p class="text-red-700 flex items-center">
              <i class="pi pi-exclamation-circle mr-2"></i>
              {{ interventionError }}
            </p>
          </div>

          <app-affair-schedule-intervention-create
            class="w-full"
            [affair]="affair"
            [selectedTechnicians]="selectedTechnicians"
            [dateRange]="dateRange()"
            [droppedDetails]="droppedDetails"
            [scheduleData]="scheduleData"
            [interventionForm]="interventionForm"
            (formError)="onInterventionFormError($event)"
            (formStateChanged)="onInterventionFormStateChanged($event)"
          ></app-affair-schedule-intervention-create>
        </div>
      </div>
    </div>
  </div>
</p-card>

<!-- Navigation buttons - moved outside the card for fixed positioning -->
<div class="navigation-buttons">
  <div class="nav-container">
    <div class="flex justify-between w-full">
      <div class="flex gap-2">
        <!-- Reset button -->
        <button
          pButton
          type="button"
          icon="pi pi-refresh"
          label="Réinitialiser"
          class="p-button-outlined p-button-danger"
          (click)="resetForm()"
          [disabled]="affairLoading"
        ></button>

        <!-- Previous button -->
        <button
          pButton
          type="button"
          [disabled]="activeStep() === 0"
          (click)="previousStep()"
          label="Précédent"
        ></button>
      </div>

      <!-- Next button -->
      <button
        pButton
        type="button"
        *ngIf="activeStep() < steps.length - 1"
        (click)="nextStep()"
        [disabled]="
          (activeStep() === 0 &&
            (!selectedProducts || selectedProducts.length === 0)) ||
          (activeStep() === 1 && !isTechniciansSelected) ||
          (activeStep() === 2 && !hasDroppedEvent) ||
          techniciansIncompatible
        "
        label="Suivant"
      ></button>

      <!-- Submit button -->
      <button
        pButton
        type="button"
        *ngIf="activeStep() === steps.length - 1"
        (click)="onSubmitIntervention()"
        [loading]="submittingIntervention"
        [disabled]="interventionFormLoading"
        label="Créer l'intervention"
        class="p-button-success"
      ></button>
    </div>
  </div>
</div>
